import script from "./BulletinII.vue?vue&type=script&setup=true&lang=js"
export * from "./BulletinII.vue?vue&type=script&setup=true&lang=js"

import "./BulletinII.vue?vue&type=style&index=0&id=f7ed6b48&scoped=true&lang=css"

import exportComponent from "/home/sino/SinoData/jenkins/.jenkins/workspace/enterpriseprodex/sxpf-cms-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7ed6b48"]])

export default __exports__